<div class="show-slider">
  @if (label()) {
    <mat-label class="show-slider__label">
      @if (hint()) {
        <mat-icon
          class="show-slider__hint"
          [matTooltip]="hint()"
        >
          info
        </mat-icon>
      }
      <div class="show-slider__label-text">
        {{ label() }}
      </div>
    </mat-label>
  }
  <div class="show-slider__container">
    <mat-slider
      class="show-slider__item"
      discrete
      showTickMarks
      disabled
      [min]="min()"
      [step]="step()"
      [max]="max()"
      [displayWith]="displayWith()"
    >
      <input
        class="show-slider__input"
        matSliderThumb
        [value]="value()"
      />
    </mat-slider>
  </div>
</div>
